import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { tableHeadersLine } from '../dataConnectMultiCluster/DataConnectMultiClusterTableHeaders';


export type DataConnectPoolDomainsSectionHeadersProps = Readonly<{
}>

export function DataConnectPoolDomainsSectionHeaders(props: DataConnectPoolDomainsSectionHeadersProps) {
  const tooltipPath = imgPath('info_normal.svg');
  return <>
    <tbody>
      <tr>
        <th className={tableHeadersLine} style={{paddingLeft: 0, width:'40%'}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-domain-name-column-header'} style={{paddingLeft: 15}}>
            {Messages.dataConnectSiteSettingsDomain()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-domain-type-column-header'}>
            {Messages.dataConnectSiteSettingsDomainType()}
          </span>
        </th>
        <th className={tableHeadersLine}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-domain-access-column-header'}>
            {Messages.dataConnectSiteSettingsDomainAccess()}
          </span>
        </th>
        <th className={tableHeadersLine} data-tb-test-id={'pool-domain-actions-column-header'} style={{paddingLeft: 15, maxWidth: 13}}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-domain-actions-column-header'}>
            {Messages.dataConnectSiteSettingsPoolActionsColumnName()}
          </span>
        </th>
      </tr>
    </tbody>
  </>;
}
